<template>
  <div>
    <div ref="box">
      <!-- question -->
      <p
        v-if="item.type === 'question'"
        style="
        padding:7px;display: inline-block;
        background-color:#424a60; color:white"
        :class="{ bold: isFolder }"
        @click="toggle"
      >
        {{ item.name }}{{ " "
        }}<b-icon
          v-if="isFolder"
          pack="fas"
          style="margin-left:10px"
          :icon="isOpen ? 'minus-circle' : 'plus-circle'"
          size=" is-small"
        ></b-icon>
      </p>
      <div
        v-else
        style="padding:7px;color:black;"
        :class="{ bold: isFolder }"
        @click="toggle"
      >
        <div
          v-if="item.lengthArrayAnswers !== item.id"
          :style="
            'position:absolute;width:2px;height:'+60+'px;border-left:2px solid #424a60'"/>
        <div
          style="display:inline-block;
                width:25px; height:25px;
                border-left:2px solid #424a60;
                border-bottom:2px solid #424a60"
        />

        <b-icon
          v-if="isFolder"
          pack="fas"
          style="margin-left:10px"
          icon="code-branch"
          size=" is-small"
        ></b-icon>
        {{ item.name }}
      </div>
      <ul v-show="isOpen" v-if="isFolder">
        <ItemTreeComponent
          style="margin-top:1em"
          class="item"
          v-for="(child, index) in item.children"
          :key="index"
          :item="child"
        />
      </ul>
    </div>
  </div>
</template>
<script>
import ItemTreeComponent from './ItemTreeComponent'
export default {
  name: 'ItemTreeComponent',
  components: {
    ItemTreeComponent
  },
  props: {
    item: Object
  },
  data: function (props) {
    return {
      isOpen: true
    }
  },
  computed: {
    isFolder: function () {
      return this.item.children && this.item.children.length
    }
  },
  methods: {
    getHeight () {
      return 3.90 * 60
    },
    toggleConditionalSection () {
      this.isOpen = false
    },
    toggle () {
      if (this.isFolder) {
        this.isOpen = !this.isOpen
      } else {
        this.isOpen = false
      }
    }
  }
}
</script>
<style scoped>
body {
  font-family: Menlo, Consolas, monospace;
  color: #444;
}
.item {
  cursor: pointer;
}
.bold {
  font-weight: bold;
}
ul {
  padding-left: 3em;
  line-height: 1.5em;
  list-style-type: dot;
}
</style>



// WEBPACK FOOTER //
// src/components/question/section/tree/ItemTreeComponent.vue